var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPlay01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon_play_01_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.177 11.873c-.342 0-.689-.096-1-.292L4.588 4.215a1.87 1.87 0 0 1-.573-2.58 1.87 1.87 0 0 1 2.581-.573L18.181 8.43a1.87 1.87 0 0 1-1.004 3.446z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#icon_play_01_svg__b)",
  d: "M5.742 18.558c-1.113 0-2.02-.834-2.02-1.858V2.723c0-1.024.902-1.858 2.02-1.858 1.566.674 2.02.834 2.02 1.858V16.7c0 1.024-.902 1.858-2.02 1.858"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.177 19.508a1.87 1.87 0 0 1-.946-3.48l13-7.632a1.87 1.87 0 0 1 1.892 3.223l-13 7.631a1.9 1.9 0 0 1-.946.258"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon_play_01_svg__b",
  x1: 5.742,
  x2: 5.742,
  y1: 18.269,
  y2: 11.923,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.522,
  stopColor: "#fff",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_play_01_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.308.77h16.738v18.737H2.308z"
})))));
export default SvgIconPlay01;